import React from 'react';
import { useStreamServeProjekte } from '@/adapter/opm-cockpit-backend/useStreamServeProjekte';
import { CreateStreamServeProjektBox } from './components/CreateStreamServeProjektBox';
import { EditStreamServeProjektRow } from './components/EditStreamServeProjektRow';

export const StreamServeConfig: React.FC = () => {
  const { data, isLoading, error } = useStreamServeProjekte();

  if (isLoading) {
    return (
      <p className="text-sm text-muted-foreground">
        Lade StreamServe-Projekte...
      </p>
    );
  }

  if (error) {
    return (
      <p className="text-sm text-destructive">
        Fehler beim Laden der StreamServe-Projekte.
      </p>
    );
  }

  return (
    <div className="space-y-4">
      <CreateStreamServeProjektBox />
      <div className="bg-white border border-table-border rounded-lg overflow-x-auto overflow-y-auto max-h-[60vh]">
        <table className="table-fixed w-full">
          <thead className="sticky top-0 z-20 bg-table-header border-b border-table-border border-l-4 border-l-table-header">
            <tr>
              <th className="text-left p-3 font-medium text-text-primary bg-table-header">
                Projektname
              </th>
              <th className="text-left p-3 font-medium text-text-primary bg-table-header">
                Version
              </th>
              <th className="text-left p-3 font-medium text-text-primary bg-table-header">
                Aktion
              </th>
            </tr>
          </thead>
          <tbody>
            {(data ?? []).length === 0 && (
              <tr>
                <td
                  colSpan={4}
                  className="p-3 text-sm text-muted-foreground italic"
                >
                  Keine StreamServe-Projekte gepflegt.
                </td>
              </tr>
            )}
            {(data ?? []).map((project) => (
              <EditStreamServeProjektRow projekt={project} />
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
